<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm(motif)" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('projects.taskRejectMotif')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row mb-5">
              <div class="col-12">
                <Input
                    container-class="form-group"
                    :name="`comment-name`+id"
                    type="text"
                    :placeholder="$t('projects.taskRejectMotifPlaceholder')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    :isRequired="true"
                    v-model="motif"/>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
            <Button type="submit"
                    id="submit_btn"
                    btn-class="btn-sm me-3"
                    size="7px 30px"
                    btn-text="button.save"
                    :is-disabled="loading || !motif"
                    :is-loading="loading"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import RequiredText from "@/components/RequiredText.vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  parent: String,
  motif: String,
  loading: { type: Boolean, default: false },
  submitForm: Function
});

const motif = ref(props.motif);

function closeModal() {
  if(props.parent) {
    $("#" + props.parent).modal("toggle");
  }
  $("#" + props.id).modal("toggle");
}
</script>

<style scoped>
</style>
